import { render, staticRenderFns } from "./CompareResults.vue?vue&type=template&id=f0999d0e&scoped=true&"
import script from "./CompareResults.vue?vue&type=script&lang=js&"
export * from "./CompareResults.vue?vue&type=script&lang=js&"
import style0 from "./CompareResults.vue?vue&type=style&index=0&id=f0999d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0999d0e",
  null
  
)

export default component.exports